<app-self-checkin kind="service" [targetId]="targetId"></app-self-checkin>
